import { ContextualHelp } from "@shared/ui/contextual-help";
import { TimeConfigurationCard } from "../timeConfiguration/timeConfiguration";
import { AddressConfigurationCard } from "../addressConfiguration/addressConfiguration";
import { DocumentTypesConfigurationCard } from "../documentTypeConfiguration/documentTypeConfiguration";
import ApplicationProcessFeesLanding from "../applicationProcessFees/landing/landing";

export function NewConnectionLanding() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <h2 className="page-subheading">New Connection Configuration</h2>
        <ContextualHelp
          title="New Connection Configuration"
          content="Configure new connection settings including response time requirements, address display formats, and required document types used throughout the platform."
        />
      </div>
      <ApplicationProcessFeesLanding />
      <TimeConfigurationCard />
      <AddressConfigurationCard />
      <DocumentTypesConfigurationCard />
    </div>
  );
}
